(function($, FUNCTIONS, cssua){
	const clickEvent = cssua.ua.desktop ? 'click' : 'tap';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		estimate(){
			if($('.special-totalhair').length) {
				const beforeRadio = $('input[name="before"]');
				const afterRadio = $('input[name="after"]');
				const detailArea = $('.js-estimateBlock');
				const pickupArea = $('.js-estimate-pickup');
				const numberArea = $('.js-estimate-number');
				const priceArea = $('.js-estimate-price');
				const tableAreaPc = $('.js-estimate-table-pc');
				const tableAreaSp = $('.js-estimate-table-sp');
				let imgPath = '';
				if(!(location.pathname.split('/')[3] === 'totalhair')) {
					imgPath = '/dark';
				}

				let corce = {
					pickup: '育毛３ヶ月(月1回)',
					number: '0',
					price: 41250,
					table: '0'
				};
				let corceNum;

				// 初期表示
				pickupArea.html(corce.pickup);
				numberArea.html(corce.number);
				priceArea.html(corce.price.toLocaleString());
				tableAreaPc.attr('src', '/mens/rn-images/special/totalhair/estimate'+imgPath+'/'+corce.table+'pc.png');
				tableAreaSp.attr('src', '/mens/rn-images/special/totalhair/estimate'+imgPath+'/'+corce.table+'sp.png');

				// ラジオ選択時
				beforeRadio.change(function(){
					// disabledをリセット
					afterRadio.prop('disabled', false);
					$('.special-totalhair-estimate-radio').removeClass(v);
					for(let i = 0; i < 7; i++) {
						// afterをリセット
						$('input.js-estimate-after'+i).prop('checked', false);
						// 選択できない項目にdisabledを付与
						if(i < Number($(this).val())) {
							$('input.js-estimate-after'+i).prop('disabled', true);
							$('input.js-estimate-after'+i).parent('.special-totalhair-estimate-radio').addClass(v);
						}
						// 詳細エリアを非表示
						detailArea.slideUp(400);
					}
				});
				afterRadio.change(function(){
					for(let l = 0; l < 7; l++) {
						// 組み合わせによってそれぞれのコースの項目を更新
						if($('input.js-estimate-before'+l).prop('checked')) {
							corceNum = Number($(this).val()) - l;
							if(corceNum === 0) {
								corce = {
									pickup: '育毛３ヶ月(月1回)',
									number: '0',
									price: 41250,
									table: '0'
								};
							}
							if(corceNum === 1) {
								corce = {
									pickup: '・バイタルEXネオ',
									number: '1,500',
									price: 99000,
									table: '1500'
								};
							}
							if(corceNum === 2) {
								corce = {
									pickup: '・バイタルEXネオ<span>&</span>・バイタルEXマイクロリターン',
									number: '4,500',
									price: 250800,
									table: '4500'
								};
							}
							if(corceNum === 3) {
								corce = {
									pickup: '・ピンポイントライズ<span>&</span>・バイタルEXマイクロリターン',
									number: '7,500',
									price: 410300,
									table: '7500'
								};
							}
							if(corceNum === 4) {
								corce = {
									pickup: '・ピンポイントライズ<span>&</span>・バイタルEXマイクロリターン',
									number: '12,000',
									price: 562100,
									table: '12000'
								};
							}
							if(corceNum === 5) {
								corce = {
									pickup: '・バイタルEXネオ<span>or</span>・ヘアシステム',
									number: '15,000',
									price: 682000,
									table: '15000'
								};
							}
							if(corceNum === 6) {
								corce = {
									pickup: '・バイタルEXネオ<span>or</span>・ヘアシステム',
									number: '18,000',
									price: 712800,
									table: '18000'
								};
							}
						}
						// コース名割り当て・詳細エリア表示
						pickupArea.html(corce.pickup);
						numberArea.html(corce.number);
						priceArea.html(corce.price.toLocaleString());
						tableAreaPc.attr('src', '/mens/rn-images/special/totalhair/estimate'+imgPath+'/'+corce.table+'pc.png');
						tableAreaSp.attr('src', '/mens/rn-images/special/totalhair/estimate'+imgPath+'/'+corce.table+'sp.png');
						detailArea.slideDown(400);
					}
				});
			}
		},
		modal(){
			if($('.special-totalhair').length) {
				$('.special-totalhair-imgBlock02-content').magnificPopup({
					delegate: 'a',
					type:'image',
					closeMarkup:'<button title="%title%" type="button" class="mfp-close"><i class="icon icon-close mfp-close"></i></button>',
					gallery: {
						enabled: true
					}
				});
				$('.special-totalhair-imgBlock03-content').magnificPopup({
					delegate: 'a',
					type:'image',
					closeMarkup:'<button title="%title%" type="button" class="mfp-close"><i class="icon icon-close mfp-close"></i></button>',
					gallery: {
						enabled: true
					}
				});
				$('.special-totalhair-imgBlock04-content_pc').magnificPopup({
					delegate: 'a',
					type:'image',
					closeMarkup:'<button title="%title%" type="button" class="mfp-close"><i class="icon icon-close mfp-close"></i></button>',
					gallery: {
						enabled: true
					}
				});
				$('.special-totalhair-imgBlock04-content_sp').magnificPopup({
					delegate: 'a',
					type:'image',
					closeMarkup:'<button title="%title%" type="button" class="mfp-close"><i class="icon icon-close mfp-close"></i></button>',
					gallery: {
						enabled: true
					}
				});
			}
		},
		fixed(){
			if($('.special-totalhair').length) {
				$(window).scroll(function(e){
					var $this = $(e.currentTarget);
					var thisScroll = $this.scrollTop();;


					if(thisScroll > '200') {
						$('.special-totalhair-fixed').addClass(a);
					} else {
						$('.special-totalhair-fixed').removeClass(a);
					}
				});
			}
		},
		loadDelayScript(){
			var _this = this;
			_this.estimate();
			_this.modal();
			_this.fixed();
		}
	};

	$(() => FUNCTIONS.loadDelayScript());
})(window.jQuery, window.FUNCTIONS, window.cssua);
